<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-input @clear="getPage({pageNum: 1})" v-model="queryParam.remarkContent" style="width:200px;margin-right:10px;" clearable placeholder="评语内容"></el-input>
        <el-select v-model="queryParam.categoryId" placeholder="所属专业" @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in specialtyList" :key="index" :label="item.categoryName" :value="item.categoryId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.remarkLevel" placeholder="评语类型" filterable @change="getPage({pageNum: 1})" :clearable="true" style="width: 200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in Tool.map2arr($enums.remarkLevel)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
        <el-button @click="queryParam=JSON.parse(JSON.stringify(oldQueryParam)),getPage({pageNum: 1})" type="default">重置</el-button>
      </div>
      <div class="text-right" style="margin-top: 10px;">
        <el-button @click="edit()" type="primary" style="margin-right: 0px;">
          <i class="icon icon_add"></i>
          新增评语
        </el-button>
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium">
        <el-table-column prop="id" label="序号" width="80">
          <template slot-scope="scope">
            {{1+page.pageSize*(page.pageNum-1)+scope.$index}}
          </template>
        </el-table-column>
        <el-table-column prop="remarkContent" label="评语内容"></el-table-column>
        <el-table-column prop="categoryNames" label="专业"></el-table-column>
        <el-table-column prop="remarkLevel" label="评语类型">
          <template slot-scope="scope">
            {{$enums.remarkLevel[scope.row.remarkLevel]}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="edit(scope.row)">编辑</el-button>
            <el-button size="mini" type="text" style="color: #E91212;" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
    <el-dialog :title="(editForm.row?'编辑':'创建')+editForm.title" v-if="editForm.show" :visible.sync="editForm.show" width="600px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <Edit :row="editForm.row" @close="getPage()"></Edit>
    </el-dialog>
  </div>
</template>
<script>
import Edit from './remark-edit'

export default {
  name: 'remark-manage',
  components: { Edit },
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { pageNum: 1, pageSize: 20, categoryLevel: 2 },
      page: { pageSize: 20, pageNum: 1 },
      editForm: { show: false, row: null, title: '评语' },
      specialtyList: [],
    }
  },
  async created () {
    await this.getPage()
    await this.getSpecialtyList()
    this.oldQueryParam = JSON.parse(JSON.stringify(this.queryParam))
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async getSpecialtyList (event) {
      this.specialtyList = await this.$HTTP.ApiCategory.getGradeTreeData(this.queryParam)
      if (event) {
        this.queryParam.specialtyId = ''
      }
      await this.getPage()
    },
    async getPage (queryParam) {
      try {
        this.editForm.show = false
        this.editForm.row = null
        // this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let newQueryParam = JSON.parse(JSON.stringify(this.queryParam))
        if (queryParam && !queryParam.pageSize) {
          this.$set(queryParam, 'pageSize', this.page.pageSize)
        }
        newQueryParam = Object.assign({}, newQueryParam, queryParam)
        let page = await this.$HTTP.GradeRemark.getPage(this.queryParam)
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async edit (row) {
      this.editForm.show = true
      if (row) {
        this.editForm.row = row
      } else {
        this.editForm.row = null
      }
    },
    async del (row) {
      try {
        let confirm = await this.$confirm('删除后将无法恢复，确定要删除该记录吗？', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          await this.$HTTP.GradeRemark.del(row.remarkId)
          await this.getPage()
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    }
  }
}
</script>
